import React from "react";
import LoginForm from "../components/LoginForm";
import Vbg from "../assets/1.mp4";

const LoginPage = () => {
  return (
    <>
      <div className="video-bg">
        <video autoPlay muted loop playsInline>
          <source src={Vbg} type="video/mp4" />
        </video>
      </div>

      <div className="auth-page">
        <LoginForm />
      </div>
    </>
  );
};

export default LoginPage;
